import React from 'react';
import { Link } from 'react-router-dom';
import { RecentEvent } from '../RecentEvent.interface';
import './RecentEventTeaser.css';

const RecentEventTeaser = (props: { teaser: RecentEvent }) => {
  // console.log(props);
  const renderTeaser = props.teaser.teaser
    ? props.teaser.teaser.split('\n').map((line, index) => <p key={index}>{line}</p>)
    : null;
  return (
    <div className="recent-event">
      {renderTeaser}
      {props.teaser.event
        ? <Link to={props.teaser.event || ""}>&rarr; přejít</Link>
        : null
      }
    </div>
  );
}

export default RecentEventTeaser;